import { Link } from "react-router-dom";

import { Anchor, Group, Title } from "@mantine/core";

import { IDashboardSectionProps } from "./dashboard-section.models";

export const DashboardSection = ({
  title,
  viewAllLabel,
  viewAllTo,
  children,
}: IDashboardSectionProps) => (
  <section>
    <Group justify="space-between" align="center" mb="md">
      <Title order={2} size="h4">
        {title}
      </Title>
      <Anchor component={Link} to={viewAllTo} size="sm" fw={500}>
        {viewAllLabel}
      </Anchor>
    </Group>

    {children}
  </section>
);
